import api from './api';

// Check if user is eligible to submit/edit review
export const checkReviewEligibility = async () => {
  const response = await api.get('/review/eligibility');
  return response.data;
};

// Get user's existing review
export const getUserReview = async () => {
  const response = await api.get('/review/my');
  return response.data;
};

// Get approved reviews (public, paginated)
export const getApprovedReviews = async (page = 1, pageSize = 10) => {
  const response = await api.get('/review', {
    params: { page, pageSize }
  });
  return response.data;
};

// Get featured 5-star reviews for homepage carousel (public)
export const getFeaturedReviews = async (count = 10) => {
  const response = await api.get('/review/featured', {
    params: { count }
  });
  return response.data;
};

// Submit new review
export const submitReview = async (reviewData) => {
  const response = await api.post('/review', reviewData);
  return response.data;
};

// Update existing review
export const updateReview = async (reviewData) => {
  const response = await api.put('/review', reviewData);
  return response.data;
};

// Dismiss review popup (close X)
export const dismissReviewPopup = async () => {
  const response = await api.post('/review/dismiss');
  return response.data;
};

// Set remind me in 30 days
export const remindMeLater = async () => {
  const response = await api.post('/review/remind-later');
  return response.data;
};

const reviewsService = {
  checkReviewEligibility,
  getUserReview,
  getApprovedReviews,
  getFeaturedReviews,
  submitReview,
  updateReview,
  dismissReviewPopup,
  remindMeLater,
};

export default reviewsService;
